import React from 'react';
import DashboardLayout from './layouts/DashboardLayout';
import { store } from './redux/store';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import LoginPage from './components/Login';
import UserManagement from './components/UserManagement';
import Contact from './components/Contact';
import Packages from './components/Packages';
import Reports from './components/Reports';
import Category from './components/Category';
import NotificationManagement from './components/NotificationManagement';
import Dashboard from './components/Dashboard';
import AddUser from './components/AddUser';
import UserAuthGuard from './guards/UserAuthGuard';
import { Toaster } from 'react-hot-toast';
import AddCategory from './components/AddCategory';
import AddNotification from './components/AddNotification';
import ResetPassword from './components/ResetPassword';
import { LoginGuard } from './guards/LoginGuard';
import ThemeSwitcher from './components/ThemeSwitcher';
import RolesManagement from './components/Roles';
import AddAdmin from './components/AddAdmin';

function App() {

  return (
    <>
      <Provider store={store}>
        <ThemeSwitcher />
        <Toaster
          position="top-center"
          reverseOrder={false}
        />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={
              <LoginGuard>
                <LoginPage />
              </LoginGuard>} />
            <Route path="resetpassword/:token" element={<ResetPassword />} />
            <Route path='/dashboard' element={
              <UserAuthGuard>
                <DashboardLayout />
              </UserAuthGuard>
            }>
              <Route path="" element={<Dashboard />} />
              <Route path="usermanagement" element={<UserManagement />} />
              <Route path="notifications" element={<NotificationManagement />} />
              <Route path="categories" element={<Category />} />
              <Route path="reports" element={<Reports />} />
              <Route path="packages" element={<Packages />} />
              <Route path="contactus" element={<Contact />} />

              {/* <Route path="adduser" element={<AddUser />} /> */}
              <Route path="adduser/:id" element={<AddUser />} />

              <Route path="addcategory" element={<AddCategory />} />
              <Route path="addcategory/:id" element={<AddCategory />} />

              <Route path="addnotification" element={<AddNotification />} />
              <Route path="addnotification/:id" element={<AddNotification />} />

              <Route path="roles" element={<RolesManagement />} />
              <Route path="addAdmin/:id?" element={<AddAdmin />} />



            </Route>
          </Routes>
        </BrowserRouter>
      </Provider>

    </>
  );
}

export default App;
